/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import editCitoyenActions, {
    editCitoyenTypes,
} from '../../../redux/user/editCitoyen'
import { Put } from '../../../serveur/axios'
// import alertActions from '../../../redux/alert'

function* editCitoyenSagas({ response }) {
    try {
        const res = yield Put(`users/citoyen/${response.id}`, response)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(editCitoyenActions.editCitoyenSuccess(res.data)),

                // yield put(
                //     alertActions.alertShow(true, {
                //         onConfirm: false,
                //         warning: false,
                //         info: false,
                //         error: false,
                //         success: true,
                //         message: response.intl.formatMessage({
                //             id: 'successSagaMessage',
                //         }),
                //         title: response.intl.formatMessage({
                //             id: 'successSagaTitle',
                //         }),
                //     })
                // ),
                yield put(goBack()),
            ])
        } else {
            yield put(editCitoyenActions.editCitoyenFailure(res))
        }
    } catch (error) {
        yield put(editCitoyenActions.editCitoyenFailure(error))
    }
}

export function* editCitoyenSaga() {
    yield takeLatest(editCitoyenTypes.EDIT_CITOYEN_REQUEST, editCitoyenSagas)
}
